import React from 'react';
import { Skeleton } from '@mui/material';

const FormulaSkeleton = () => {
  return <Skeleton height={24} width={120} />;
};

export default FormulaSkeleton;
